// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    const scrollcontent = accordion.getAttribute("js-acc-single-trigger-scroll") || null;
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });   
}
// accordions js end

(function() {
  
      faq_taggol();  
  
  const header_operlay = document.querySelector("[data-banner-header-overlay]");
  if(header_operlay){
    document.body.classList.add('header-overlay');
  } 
  
})();  





  const menuItems = document.querySelectorAll(".menu_hover");
  function setActive(title, element) {
  const megaWrapper = element?.closest(".mega_main_wrp");

  if (!megaWrapper) return;

  const contentBlocks = megaWrapper.querySelectorAll(".menu-product-list-desk .grandchildlink-products");

  contentBlocks.forEach(block => block.style.display = "none");

  const activeBlock = megaWrapper.querySelector(
    `.menu-product-list-desk .grandchildlink-products[data-content="${title}"]`
  );

  if (activeBlock) {
    activeBlock.style.display = "block";
  }
}

  // hover event
  menuItems.forEach(item => {
    item.addEventListener("mouseenter", function () {
      const title = this.getAttribute("data-title");
      setActive(title,this);
    });
  });

  // 👇 default first active
  if (menuItems.length > 0) {
    const firstTitle = menuItems[0].getAttribute("data-title");
    console.log(menuItems[0],"firstTitle")
    // setActive(firstTitle,menuItems[0]);
  }



const wrapper = document.querySelector(".video-wrapper");

if (wrapper) {
  const video = wrapper.querySelector(".video-element");
  const playBtn = wrapper.querySelector(".play-btn");

  playBtn.addEventListener("click", (e) => {
    e.stopPropagation();
    video.play();
    playBtn.style.display = "none";
    video.setAttribute("controls", true);
  });


  video.addEventListener("ended", () => {
    playBtn.style.display = "block";
    video.removeAttribute("controls");
  });

  video.addEventListener("pause", () => {
    if (!video.ended) {
      playBtn.style.display = "block";
    }
  });
}

const steps = document.querySelectorAll('.form-input-wapper');
const progressText = document.querySelector('.progress_count_wrp');

// ALL previous & next buttons
const prevBtns = document.querySelectorAll('.next-prev-button .previous_btn');
const nextBtns = document.querySelectorAll('.next-prev-button .next_btn[type="button"]');


let currentStep = 0;

// ======================
// SHOW ACTIVE STEP
// ======================
function showStep(index) {
  steps.forEach((step, i) => {
    step.style.display = (i === index) ? 'block' : 'none';
     step.classList.add(`step-${i + 1}`);
  });
  updateProgress();
  updateButtons();
}

// ======================
// UPDATE PROGRESS TEXT
// ======================
function updateProgress() {
  // Update text
  if (progressText) {
    progressText.innerHTML = `
      ${String(currentStep + 1).padStart(2, '0')} | ${String(steps.length).padStart(2, '0')}
    `;
  }

  // Update progress bar width
  if (progressText) {
    const progressPercent = ((currentStep + 1) / steps.length) * 100;
    progressText.style.width = `${progressPercent}%`;
  }
}

// ======================
// BUTTON VISIBILITY
// ======================
function updateButtons() {
  prevBtns.forEach(btn => {
    btn.style.display = currentStep === 0 ? 'none' : 'inline-block';
  });
  
}

// ======================
// NEXT BUTTON CLICK
// ======================
nextBtns.forEach(btn => {
  btn.addEventListener('click', () => {
    console.log(btn.type,"btn.type")
    if (btn.type === "button") {
    const wrapper = btn.closest('.form-input-wapper');
    if (wrapper) {
      const stepClass = [...wrapper.classList].find(cls => cls.startsWith('step-'));
      if (stepClass) {
        const stepNumber = stepClass.replace('step-', '');
        let savedSteps = JSON.parse(localStorage.getItem('stepNumber')) || [];
        if (!savedSteps.includes(stepNumber)) {
          savedSteps.push(stepNumber);
        }
        localStorage.setItem('stepNumber', JSON.stringify(savedSteps));
      }
    }
    const nextStep = btn.dataset.nextStep;
    if (nextStep) {
      currentStep = parseInt(nextStep, 10) - 1;
      showStep(currentStep);
    } else {
      if (currentStep < steps.length - 1) {
        currentStep++;
        showStep(currentStep);
      
          // Current step checked value
          const checkedValues = [];
          const allblock = event.target.closest('.form-input-wapper');
          const cards = allblock.querySelectorAll('.form-input-card');
          cards.forEach(card => {
              const checkedInput = card.querySelector('input:checked');

              if (checkedInput) {
                  checkedValues.push(checkedInput.value);
              }
          });
          console.log(checkedValues, "current checked values");
          // Next step
          const nextWrapper = steps[currentStep];
          console.log(nextWrapper,'nextWrapper')
          if (nextWrapper) {
              const nextCards = nextWrapper.querySelectorAll('.step_input-wrp .shopify-block');
              nextCards.forEach(card => {
                const getvalue = card.querySelector('input')
                  const matchValues = getvalue.dataset.valueMatch;
                  console.log(matchValues,"matchValues")
                  if (matchValues) {
                      const valuesArray = matchValues
                          .split(',')
                          .map(value => value.trim());

                      // Match check
                      const isMatch = checkedValues.some(value =>
                          valuesArray.includes(value)
                      );
                      if (isMatch) {
                          card.style.display = "block";
                      } else {
                          card.style.display = "none";
                      }
                  }
              });
          }
      } else {
        console.log('Form Completed!');
      }
    }
  }
  });
});

// ======================
// PREVIOUS BUTTON CLICK
// ======================
prevBtns.forEach(btn => {
  btn.addEventListener('click', () => {
    let savedSteps = JSON.parse(localStorage.getItem('stepNumber')) || [];
    if (savedSteps.length > 0) {
      // Get last step
      const lastStep = savedSteps[savedSteps.length - 1];
      currentStep = parseInt(lastStep, 10) - 1;
      showStep(currentStep);
      console.log("Previous step:", lastStep);
      // Remove shown step from storage
      savedSteps.pop();
      // Update localStorage
      localStorage.setItem('stepNumber', JSON.stringify(savedSteps));
    } else {
      // Old logic
      if (currentStep > 0) {
        currentStep--;
        showStep(currentStep);
      }
    }
  });
});

// ======================
// INITIAL LOAD
// ======================
showStep(currentStep);

// ==============Form Submit======================
async function onSubmitFunction(event, button) {
  event.preventDefault();
  event.stopImmediatePropagation();

  const form = button.closest("form");

  if (!form) {
    console.error("Form not found");
    return;
  }

  const formData = new FormData(form);
  console.log(formData,"formData")

  const params = new URLSearchParams();
    console.log(formData,"formData");
    formData.forEach((value, key) => {
        if (!value) return;
        // Price range
        if (key === "contact[filter.v.price.gte , filter.v.price.lte]") {
            // 51–100 -> ["51", "100"]
            const [minPrice, maxPrice] = value.split(/[–-]/);
            params.append("filter.v.price.gte", minPrice.trim());
            // params.append("filter.v.price.lte", maxPrice.trim());
            if (maxPrice && maxPrice.trim() !== "") {
                params.append("filter.v.price.lte", maxPrice.trim());
            } 

        } else {
            const match = key.match(/^contact\[(.*)\]$/);
            if (match && match[1]) {
                params.append(match[1], value);
            }
        }
    });

  // collection url attr
  const collectionUrl =
    button
      .closest(".dart-finder-wrp")
      ?.getAttribute("data-collection-url") ||
    "https://dinodarts.de/collections/all";

  const finalUrl = `${collectionUrl}?${params.toString()}`;

  console.log(finalUrl, "finalUrl");
  // const encodedUrl = encodeURI(finalUrl);
  // console.log(encodedUrl,"encodedUrl")
  // return;

  // redirect
  window.location.href = finalUrl;
}

function onInputChange(event, element) {
    const isSubmit = event.target.getAttribute('data-submit');
    const step = element.dataset.step;

    console.log(isSubmit, "pppppp");

    const currentStepWrapper = element.closest('.form-input-wapper');

    if (currentStepWrapper) {
        const nextBtn = currentStepWrapper.querySelector('.next_btn');
            if (nextBtn) {
              if (isSubmit === "true") {
                    nextBtn.setAttribute('type', 'submit');
                    nextBtn.setAttribute('onclick', 'onSubmitFunction(event, this);');
                    nextBtn.removeAttribute('data-next-step');
                     nextBtn.removeAttribute('disabled');
                } else {
                    nextBtn.setAttribute('type', 'button');
                    nextBtn.removeAttribute('onclick');
                    nextBtn.setAttribute('data-next-step', step);
                    nextBtn.removeAttribute('disabled');
                }
            }
        }
        
}

window.onload = function () {
    localStorage.removeItem("stepNumber");
};

document.addEventListener("DOMContentLoaded", function () {

  const wrappers = document.querySelectorAll('.tooltip-content.tooltip_content_show');

  wrappers.forEach((wrapper) => {

    const p = wrapper.querySelector('p');
    const tooltip = wrapper.querySelector('.tooltip_content');

    const textNode = p.childNodes[0];

    if (!textNode) return;

    p.addEventListener('mousemove', function (e) {

      // LAST character position
      const range = document.createRange();

      const textLength = textNode.textContent.trim().length;

      range.setStart(textNode, textLength - 1);
      range.setEnd(textNode, textLength);

      const rect = range.getBoundingClientRect();

      // Exact end of last character
      const textEnd = rect.right;

      // Mouse position
      const mouseX = e.clientX;

      // 25px after text end
      if (mouseX >= textEnd && mouseX <= textEnd + 25) {

        tooltip.style.display = 'block';
        tooltip.style.opacity = '1';
        tooltip.style.visibility = 'visible';

      } else {

        tooltip.style.display = 'none';
        tooltip.style.opacity = '0';
        tooltip.style.visibility = 'hidden';

      }

    });

    p.addEventListener('mouseleave', function () {

      tooltip.style.display = 'none';
      tooltip.style.opacity = '0';
      tooltip.style.visibility = 'hidden';

    });

  });

});


// serach in mobile
(function () {
  const stopEvent = (e) => {
    const searchArea = e.target.closest('.search-modal__form');
    if (!searchArea) return;

    e.stopPropagation();
  };

  document.addEventListener('mousedown', stopEvent, true);
  document.addEventListener('click', stopEvent, true);
  document.addEventListener('pointerdown', stopEvent, true);
})();


document.addEventListener('DOMContentLoaded', () => {
    const items = document.querySelectorAll('.faq-shipping-section-item');

    if (items.length) {
        items.forEach(item => {
            item.addEventListener('click', () => {
                const targetId = item.getAttribute('data-content');
               

                document.querySelectorAll('.faq-shipping-section-item').forEach(content => {
                    content.classList.remove('active');
                });
                 item.classList.add('active');
                document.querySelectorAll('.faq-tab-content').forEach(content => {
                    content.classList.add('hidden');
                });

                const targetContent = document.querySelector(targetId);
                console.log(targetContent.querySelectorAll('.accordion').length,"pppppppp");
                

                if (targetContent) {
                    targetContent.classList.remove('hidden');
                }
            });
        });
      
        items.forEach(item => {
            const targetId_ = item.getAttribute('data-content');
            console.log(targetId_,"targetId_")
            const targetDIV = document.querySelector(targetId_);


            if (targetDIV && targetId_) {
                const firstcount = targetDIV.querySelectorAll('.accordion').length;

                const countFaq = item.querySelector('.count-faq');
                if (countFaq) {
                    countFaq.innerHTML = firstcount;
                }
            }
        });

    }
});

//faq serach logic

function scrollToVisibleAccordion() {
    const accordions = document.querySelectorAll('.faq-tab-content-wrp .accordion');

    const visibleAccordion = [...accordions].find((accordion) => {
        return !accordion.classList.contains('hidden');
    });

    if (visibleAccordion) {
        const header = document.querySelector('header'); // Update selector if needed
        const headerHeight = header ? header.offsetHeight : 0;

        const elementPosition =
            visibleAccordion.getBoundingClientRect().top + window.pageYOffset;

        window.scrollTo({
            top: elementPosition - headerHeight,
            behavior: 'smooth'
        });
    }
}
document.addEventListener("DOMContentLoaded", () => {

    const searchInput = document.querySelector("#Search-In-Modal-1-1");

    if (!searchInput) return;

    // Get parent search form
    const searchForm = searchInput.closest("form");

    // Prevent form submit (Enter & Search button)
    if (searchForm) {
        searchForm.addEventListener("submit", function (e) {
            e.preventDefault();
            scrollToVisibleAccordion();
        });
    }

    // Prevent Enter key redirect
    searchInput.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
            e.preventDefault();
               scrollToVisibleAccordion();
        }
    });

    // Hide predictive search only for this search box
    const searchWrapper = searchInput.closest(".header-search-full");
    if (searchWrapper) {
        const predictiveSearch = searchWrapper.querySelector(".predictive-search");
        if (predictiveSearch) {
            predictiveSearch.style.display = "none";
        }
    }

    function filterFaq() {

        const search = searchInput.value.trim().toLowerCase();

        const accordions = document.querySelectorAll(".collapsible-content .accordion");

        let totalFound = 0;

        accordions.forEach((accordion) => {

            const title = accordion.querySelector(".accordion__title")
                ?.textContent
                .trim()
                .toLowerCase();

            const details = accordion.querySelector("details");

            if (search === "") {

                accordion.classList.remove("hidden");

                if (details) {
                    details.removeAttribute("open");
                }

                totalFound++;

            } else if (title && title.includes(search)) {

                accordion.classList.remove("hidden");

                if (details) {
                    details.setAttribute("open", "open");
                }

                totalFound++;

            } else {

                accordion.classList.add("hidden");

                if (details) {
                    details.removeAttribute("open");
                }

            }

        });

        let message = document.querySelector(".faq-search-empty");

       if (message) {
            if (totalFound === 0) {
                message.classList.remove("hidden");
            } else {
                message.classList.add("hidden");
            }
        }

        if (totalFound === 0) {
            message.classList.remove("hidden");
        } else {
            message.classList.add("hidden");
        }
    }

    searchInput.addEventListener("input", filterFaq);

});

// DINODARTS FLIGHT SWATCH FIX 2026-09-15
(() => {
  const flightSwatchMap = {
    "l-style-barflight-2ba": ["Blau","Neongelb","Neongrün","Neonorange","Neonpink","Rot","Schwarz","Weiß"],
    "l-style-l1-ez-dimple-champagne-standrad": ["Schwarz","Blau","Clear Blau","Rot"],
    "l-style-l1-ez-fantom": ["Transparent","Schwarz","Rot"],
    "l-style-l1-kpro-kami-standard": ["Blau","Neongrün","Schwarz","Neongelb","Rot","Weiß"],
    "l-style-l3-ez-fantom": ["Neongelb"],
    "l-style-l3-kpro-kami-shape": ["Blau","Schwarz","Dunkelgrün","Metallic","Hellblau","Orange","Pink","Lila","Rot","Weiß","Gelb","Miracle"],
    "signature-champagne-flight-l1-ez-standard-dominik-grullich-white": ["Schwarz"],
    "signature-champagne-flight-l1-ez-standard-l-style-ryb-series-type-d-clear-white": ["Transparent/Weiß"],
    "signature-champagne-flight-l1-ez-standard-maria-obrien-v2-gray": ["Grau"],
    "signature-champagne-flight-l1-ez-standard-prime-series": ["Bunt","Pink","Rot","Türkis"],
    "signature-champagne-flight-l1-ez-standard-ricardo-perez-clear-white": ["Blau"],
    "signature-champagne-flight-l1-ez-standard-robyn-byrne-v2-clear-white": ["Grün"],
    "signature-champagne-flight-l1-ez-standard-sho-okano-black": ["Mehrfarbig"],
    "signature-champagne-flight-l1-ez-standard-wayne-mardle-type-b-white": ["Weiß"],
    "signature-champagne-flight-l1-ez-standard-wayne-mardle-type-c-white": ["Weiß"],
    "l-style-two-tone-l1-ez-standard": ["Blau","Grün","Orange","Pink","Lila","Rot"],
    "windson-elix-flight-shaft-s": ["Blau","Rot","Transparent"],
    "windson-elix-flight-shaft-m": ["Blau","Transparent"]
  };

  const swatchBackground = (name) => {
    const key = String(name || "").trim().toLowerCase();
    const colors = {
      "blau": "#1869C9",
      "clear blau": "#7EC8F5",
      "hellblau": "#8ED8F8",
      "türkis": "#18B9B5",
      "grün": "#2EA44F",
      "dunkelgrün": "#1E5C3A",
      "neongrün": "#7CFF00",
      "gelb": "#FFD51F",
      "neongelb": "#CFFF16",
      "orange": "#F28C28",
      "neonorange": "#FF7A00",
      "pink": "#F04F9B",
      "neonpink": "#FF2D95",
      "lila": "#8D5AC7",
      "rot": "#D71920",
      "schwarz": "#161616",
      "grau": "#8A8A8A",
      "weiß": "#FFFFFF"
    };
    if (colors[key]) return colors[key];
    if (key === "transparent" || key === "transparent/weiß") {
      return "linear-gradient(135deg,#ffffff 0 46%,#d7d7d7 46% 54%,#ffffff 54% 100%)";
    }
    if (key === "metallic") {
      return "linear-gradient(135deg,#8e8e8e 0%,#f0f0f0 45%,#8a8a8a 100%)";
    }
    if (key === "bunt" || key === "mehrfarbig" || key === "miracle") {
      return "conic-gradient(#e53935,#fdd835,#43a047,#1e88e5,#8e24aa,#e53935)";
    }
    return "#D9D9D9";
  };

  const applyFlightSwatches = (root = document) => {
    root.querySelectorAll(".product-card-wrapper").forEach((card) => {
      const productLink = card.querySelector('a[href*="/products/"]');
      if (!productLink) return;

      const match = productLink.getAttribute("href")?.match(/\/products\/([^?/#]+)/);
      const handle = match?.[1];
      const optionValues = handle ? flightSwatchMap[handle] : null;
      if (!optionValues) return;

      const swatches = card.querySelectorAll(".card-color-swatch .color-swatch");
      swatches.forEach((swatch, index) => {
        const value = optionValues[index];
        if (!value) return;
        swatch.style.background = swatchBackground(value);
        swatch.style.backgroundColor = "";
        swatch.setAttribute("title", value);
        swatch.setAttribute("aria-label", value);
        swatch.dataset.flightSwatchFixed = "true";
      });
    });
  };

  let scheduled = false;
  const scheduleApply = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      applyFlightSwatches();
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleApply, { once: true });
  } else {
    scheduleApply();
  }

  new MutationObserver(scheduleApply).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
